'use strict'; // eslint-disable-line strict

// fetch() polyfill for making API calls.
require('whatwg-fetch');
